
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21.071","height":"20.461"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Manage_Users","data-name":"Manage Users","transform":"translate(-322.224 -385.75)","fill":"none","stroke":"#5a677d","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"id":"Path_20279","data-name":"Path 20279","d":"M9.687 9.566a3.383 3.383 0 112.537 4.056 3.376 3.376 0 01-2.537-4.056z","transform":"translate(322.48 386)"}}),_c('path',{attrs:{"id":"Path_20280","data-name":"Path 20280","d":"M5.931 19.3s.841-3.287 7.052-3.287 6.938 3.287 6.938 3.287","transform":"translate(322.48 386)"}}),_c('circle',{attrs:{"id":"Ellipse_356","data-name":"Ellipse 356","cx":"1.796","cy":"1.796","r":"1.796","transform":"translate(327.171 391.361)"}}),_c('path',{attrs:{"id":"Path_20281","data-name":"Path 20281","d":"M11.477 7.008l-.077-.763.246-.143a1.664 1.664 0 10-1.665-2.883l-.247.142a4.975 4.975 0 00-1.581-.91v-.287a1.664 1.664 0 00-3.328 0v.284a4.988 4.988 0 00-1.582.913L3 3.22A1.664 1.664 0 001.335 6.1l.246.142a5.043 5.043 0 000 1.825l-.246.142A1.666 1.666 0 003 11.1l.247-.143a4.977 4.977 0 001.581.911v.284a1.664 1.664 0 103.328 0v-.284a5 5 0 001.194-.613","transform":"translate(322.48 386)"}})])])
          )
        }
      }
    